/** Copy for the additive Instagram entry. Legacy website copy is unchanged. */
export const INSTAGRAM_INTAKE_COPY = {
  en: {
    hint: 'Paste your website or an Instagram profile, post, Reel, or carousel link.',
    needsSource:
      'Add your website or one Instagram link to continue. TikTok alone is not supported yet.',
    invalidLink:
      'Use an Instagram profile, post, Reel, or carousel link. Shop and login links are not supported.',
    singleSource:
      'Use this Instagram link on its own, or add an Instagram profile alongside your website.',
    source: 'Business source',
    reading: 'Reading your Instagram source…',
    partial: 'Review your Instagram details',
    partialBody:
      'Please review the available details and add what is missing. Your link is saved.',
    unavailable:
      'We could not read this Instagram source right now. Your link and any collected details are saved.',
    analysisUnavailable: 'Instagram analysis unavailable',
    analysisUnavailableBody:
      'We collected your Instagram information, but could not finish analyzing it. Your link and collected details are saved.',
    ambiguous:
      'Confirm which business this Instagram content describes before continuing.',
    edit: 'Edit details',
    change: 'Change link',
    reanalysis: 'Analyzing again may use your allowance.',
  },
  ar: {
    hint: 'ألصق رابط موقعك أو حساب أو منشور أو ريل أو منشور متعدد الصور على إنستغرام.',
    needsSource:
      'أضف موقعك أو رابط إنستغرام واحدًا للمتابعة. تيك توك وحده غير مدعوم بعد.',
    invalidLink:
      'استخدم رابط حساب أو منشور أو ريل أو منشور متعدد الصور على إنستغرام. روابط المتجر وتسجيل الدخول غير مدعومة.',
    singleSource:
      'استخدم رابط إنستغرام هذا وحده، أو أضف رابط حساب إنستغرام بجانب موقعك.',
    source: 'مصدر النشاط',
    reading: 'نقرأ مصدرك على إنستغرام…',
    partial: 'راجع معلومات نشاطك على إنستغرام',
    partialBody: 'راجع المعلومات المتاحة وأكمل الناقص. رابطك محفوظ.',
    unavailable: 'تعذّرت قراءة مصدر إنستغرام الآن. رابطك وأي معلومات جُمعت محفوظة.',
    analysisUnavailable: 'تعذّر إكمال تحليل إنستغرام',
    analysisUnavailableBody:
      'جمعنا معلومات حسابك على إنستغرام، لكن تعذّر إكمال تحليلها. رابطك والمعلومات التي جُمعت محفوظة.',
    ambiguous: 'أكّد النشاط الذي يصفه محتوى إنستغرام هذا قبل المتابعة.',
    edit: 'تعديل التفاصيل',
    change: 'تغيير الرابط',
    reanalysis: 'قد تستهلك إعادة التحليل من رصيدك المتاح.',
  },
} as const;
